import { ACTION } from './constants';

const initialState = {
    modalParameters: {},
    showModal: false,
    modalName: '',
    showHeader: true,
};

export default function modalReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.GET_CATEGORY :
            return {...state , category:action.data};
        case ACTION.GET_SUBJECT :
            return {...state , subject:action.data.subjects};
        case ACTION.CLEAR_SUBJECT :
            return {...state , subject: null };
        case ACTION.SEND_OTP :
            return {...state , sendOtp:action.data};
        case 'GET_WRITE_TO_TOKEN':
                return {...state, token: action.data}
        case ACTION.POST_WRITE_US :
            return {...state , writeUs:action.data};
        default:
            return state;
    }
}
